exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__content___295BU{margin-top:9rem;display:grid;gap:2rem}", ""]);

// exports
exports.locals = {
	"content": "index-module__content___295BU"
};